import moment from 'moment-timezone';

export const formatDateWithTimezone = (date: string, timezone?: string) => {
  return moment(date)
    .tz(timezone || 'UTC')
    .format('YYYY-MM-DD HH:mm');
};
